var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[
            {'erd-login-button-active': _vm.selectedMode === _vm.name },
            'erd-login-button w-full p-5',
            'border border-1 rounded-md',
            'transition-all duration-300',
            'flex flex-row space-x-4'
        ],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.selectMode()}}},[_c('div',{staticClass:"w-7",domProps:{"innerHTML":_vm._s(_vm.logos[_vm.name])}}),_c('div',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }